import { render } from "./Search.vue?vue&type=template&id=70c4634a&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=70c4634a&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-70c4634a"

export default script